import type { MetricFilterAdapter } from "@/metrics/runtime-adapters"

import type { RunRowLike } from "@/types/RunRow"

export function getHighlightValueFromRow(
  runRows: RunRowLike[],
  simulationOutputId: string | null,
  metricId: string,
  metricRecord?: MetricFilterAdapter,
): number | string | null {
  if (!simulationOutputId) {
    return null
  }
  const row = runRows.find((r) => r.simulation_output_id === simulationOutputId)
  const output = row?.metric_outputs?.[metricId]
  if (!output) {
    return null
  }
  if (metricRecord) {
    return metricRecord.getHighlightValueForMetricOutput(output)
  }
  return output.float_value ?? output.string_value ?? null
}
